// extracted by mini-css-extract-plugin
export default {"modalBody":"adminActionsInfoModal_modalBody__a+R-C","modalBodyWarning":"adminActionsInfoModal_modalBodyWarning__k7aQ5","modalBodyInfo":"adminActionsInfoModal_modalBodyInfo__tXxZ1"};